import React, { Component } from "react"
import styled from "styled-components"
import { guid, arraysEqualFields } from "../../util/random_utils"
import { KeywordTagMatchingItem } from "./key_word_tag_matching_item"
import { appStrings } from "../../common/strings/app_strings"

const { keywordTagMatching, tagMatchingSubtext, addAnother, submit } = appStrings.connectedApps
const setupStateTagKeywords = (tagKeywords, tags) => {
    return tagKeywords.reduce((acc, t) => {
        const tag = tags.items[t.tagId]
        return tag ? [...acc, {
            ...t,
            tag,
            guid: guid(),
        }] : acc
    }, [])
}

const newField = guid => ({ guid, tagId: "", keyword: "", id: null, tag: null })

export class KeywordTagMatchingController extends Component {
    constructor(props) {
        super(props)
        this.state = {
            tagKeywords: [],
            showSubmit: false,
        }
    }

    componentDidMount() {
        const { tagKeywords, tags } = this.props
        const tagKeywordsWithGuids = setupStateTagKeywords(tagKeywords, tags)
        const newTagKeywords = [
            ...tagKeywordsWithGuids,
            { ...newField(guid()) },
        ]
        this.setState({ tagKeywords: [...newTagKeywords] })
    }

    componentDidUpdate({ tagKeywords: prevKeywords }) {
        const { tagKeywords, tags } = this.props
        if (!arraysEqualFields(tagKeywords, prevKeywords, ["id", "keyword", "tagId"])) {
            const tagKeywordsWithGuids = setupStateTagKeywords(tagKeywords, tags)
            const addEmptyField = this.state.tagKeywords.length != tagKeywordsWithGuids.length
            const newTagKeywords = addEmptyField
                ? [...tagKeywordsWithGuids, { ...newField(guid()) }]
                : tagKeywordsWithGuids
            this.setState({ tagKeywords: newTagKeywords, showSubmit: false })
        }
    }

    handleAddField = () => {
        const { tagKeywords } = this.state
        const newTagKeywords = [...tagKeywords, { ...newField(guid()) }]
        this.setState({ tagKeywords: [...newTagKeywords] })
    }

    removeTagMatch = idToRemove => {
        const { tagKeywords } = this.state
        if (tagKeywords.length === 1) {
            const clearField = newField(idToRemove)
            this.setState({ tagKeywords: [clearField], showSubmit: true })
            return
        }

        const newTagKeyWords = tagKeywords.filter(element => {
            return element.guid !== idToRemove
        })
        this.setState({
            tagKeywords: newTagKeyWords,
            showSubmit: true,
        })
    }

    sendTagKeyword = (guid, keyword, tag) => {
        const tagId = tag ? tag.id : ""
        const newTagKeywords = this.state.tagKeywords.reduce((acc, cur) => {
            return cur.guid === guid
                ? [...acc, { ...cur, tagId, keyword, tag }]
                : [...acc, cur]
        }, [])
        const invalidField = newTagKeywords.find(field => {
            const fieldIsEmpty = !field.keyword && !field.tag
            return (!field.keyword || !field.tag) && !fieldIsEmpty
        })
        this.setState({ tagKeywords: newTagKeywords, showSubmit: !invalidField })
    }

    handleSubmit = () => {
        this.props.handleUpdateTagKeywords(
            this.state.tagKeywords,
            this.props.configId,
        )
    }

    render() {
        const { tagKeywords, showSubmit } = this.state
        const { team, teams, personalTeamId, tags } = this.props
        return (
            <KeywordTagMatchingWrapper>
                <h5>{keywordTagMatching}</h5>
                <span className="subtext">{tagMatchingSubtext}</span>
                <div>
                    {tagKeywords.map(element => {
                        const { guid } = element
                        return (
                            <KeywordTagMatchingItem
                                removeTagMatch={this.removeTagMatch}
                                tagId={element.tagId}
                                tag={element.tag}
                                key={guid}
                                guid={guid}
                                keyword={element.keyword}
                                sendTagKeyword={this.sendTagKeyword}
                                team={team}
                                teams={teams}
                                viewerPersonalTeamId={personalTeamId}
                                tags={tags}
                            />
                        )
                    })}
                </div>
                <div className="button-wrapper">
                    <span onClick={this.handleAddField} className="link">
                        {addAnother}
                    </span>
                    {showSubmit && (
                        <span className="link" onClick={this.handleSubmit}>
                            {submit}
                        </span>
                    )}
                </div>
            </KeywordTagMatchingWrapper>
        )
    }
}

const KeywordTagMatchingWrapper = styled.div`
    .subtext {
        font-weight: 400;
        font-size: small;
        margin: 0;
    }
    .add-field {
        height: 25px;
        width: 25px;
        border-radius: 4px;
    }
    .button-wrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 10px;
        .link {
            text-align: right;
        }
    }
`



// WEBPACK FOOTER //
// ./src/components/connected_apps/keyword_tag_matching_controller.jsx